// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Wl6J","selects":"Documents_selects__3rQyg"};